<script lang="ts">
  import { page } from '$app/stores';
  import { fly, fade } from 'svelte/transition';
  import { onMount } from 'svelte';

  let mounted = false;
  
  onMount(() => {
    mounted = true;
  });

  const goBack = () => {
    history.back();
  };
</script>

<div class="container relative h-screen w-full overflow-hidden">
  {#if mounted}
    <div class="glitch-container" in:fly={{ y: -20, duration: 700 }}>
      <h1 class="glitch-text">
        {$page.status}
      </h1>
      <div class="error-title">
        {#if $page.status === 404}
          Page not found
        {:else if $page.status === 500}
          Server error
        {:else if $page.status === 403}
          Access denied
        {:else}
          Error
        {/if}
      </div>
    </div>
    
    <div in:fade={{ duration: 500, delay: 300 }} class="absolute left-0 right-0 bottom-0">
      <div class="bottom-error">
        <div class="error-content">
          <div class="error-message">
            <div class="message-text">
              <span class="message-description">
                {$page.error?.message || 'エラーが発生しました'}
              </span>
            </div>

            <div class="action-buttons">
              <button class="action-button secondary" on:click={goBack}>
                <svg class="button-icon" viewBox="0 0 24 24" fill="none">
                  <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                戻る
              </button>
              <a href="/" class="action-button secondary">
                <svg class="button-icon" viewBox="0 0 24 24" fill="none">
                  <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 22V12H15V22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                ホーム
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  {/if}
</div>

<style>
  .container {
    padding: 0;
    margin: 0;
  }

  .glitch-container {
    position: absolute;
    top: 15vh;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .glitch-text {
    position: relative;
    font-size: 20vw;
    font-weight: 800;
    text-shadow: 0.05em 0 0 rgba(255, 0, 0, 0.75),
                -0.05em -0.025em 0 rgba(0, 255, 0, 0.75),
                0.025em 0.05em 0 rgba(0, 0, 255, 0.75);
    animation: glitch 3s infinite;
    margin: 0;
    line-height: 0.8;
    letter-spacing: -0.02em;
  }

  .error-title {
    font-size: 1.5rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-top: 0.5em;
    opacity: 0.8;
    text-align: center;
  }
  
  @keyframes glitch {
    0% {
      text-shadow: 0.05em 0 0 rgba(255, 0, 0, 0.75),
                  -0.05em -0.025em 0 rgba(0, 255, 0, 0.75),
                  0.025em 0.05em 0 rgba(0, 0, 255, 0.75);
    }
    14% {
      text-shadow: 0.05em 0 0 rgba(255, 0, 0, 0.75),
                  -0.05em -0.025em 0 rgba(0, 255, 0, 0.75),
                  0.025em 0.05em 0 rgba(0, 0, 255, 0.75);
    }
    15% {
      text-shadow: -0.05em -0.025em 0 rgba(255, 0, 0, 0.75),
                  0.025em 0.025em 0 rgba(0, 255, 0, 0.75),
                  -0.05em -0.05em 0 rgba(0, 0, 255, 0.75);
    }
    49% {
      text-shadow: -0.05em -0.025em 0 rgba(255, 0, 0, 0.75),
                  0.025em 0.025em 0 rgba(0, 255, 0, 0.75),
                  -0.05em -0.05em 0 rgba(0, 0, 255, 0.75);
    }
    50% {
      text-shadow: 0.025em 0.05em 0 rgba(255, 0, 0, 0.75),
                  0.05em 0 0 rgba(0, 255, 0, 0.75),
                  0 -0.05em 0 rgba(0, 0, 255, 0.75);
    }
    99% {
      text-shadow: 0.025em 0.05em 0 rgba(255, 0, 0, 0.75),
                  0.05em 0 0 rgba(0, 255, 0, 0.75),
                  0 -0.05em 0 rgba(0, 0, 255, 0.75);
    }
    100% {
      text-shadow: -0.025em 0 0 rgba(255, 0, 0, 0.75),
                  -0.025em -0.025em 0 rgba(0, 255, 0, 0.75),
                  -0.025em -0.05em 0 rgba(0, 0, 255, 0.75);
    }
  }

  .bottom-error {
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(10px);
    width: 100%;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  .error-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 1.5rem;
  }

  .error-message {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .icon-wrapper {
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .error-icon {
    height: 100%;
    width: 100%;
    stroke-width: 1.5;
    fill: none;
  }

  .message-text {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .message-title {
    font-weight: 600;
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.9);
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  .message-description {
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.6);
  }

  .action-buttons {
    display: flex;
    gap: 0.75rem;
  }

  .action-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    height: 36px;
    padding: 0 1rem;
    border-radius: 4px;
    font-size: 0.875rem;
    font-weight: 500;
    transition: all 0.2s;
    cursor: pointer;
    text-decoration: none;
  }

  .action-button.secondary {
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.9);
    border: none;
  }

  .action-button.secondary:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  .action-button.primary {
    background: rgba(59, 130, 246, 0.2);
    color: rgb(59, 130, 246);
    border: none;
  }

  .action-button.primary:hover {
    background: rgba(59, 130, 246, 0.3);
  }

  .button-icon {
    width: 16px;
    height: 16px;
    stroke: currentColor;
  }

  @media (max-width: 640px) {
    .error-message {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .action-buttons {
      width: 100%;
      justify-content: space-between;
    }
  }
</style> 